import React from 'react';
import { useArtGalleryState } from './ArtGallery.state';
import ArtGalleryView from './ArtGallery.view';
import { IImageData } from '../type';

interface ArtGalleryProps {
    onImageSelect: (images: IImageData[]) => void;
}

const ArtGallery: React.FC<ArtGalleryProps> = ({ onImageSelect }) => {
    const state = useArtGalleryState(onImageSelect);

    return <ArtGalleryView {...state} />;
};

export default ArtGallery;
